import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../searchers";
import { Adapter } from "../../../../shared/adapter";
import { SearchersAdapter } from "../../../../adapter/searchers-adapter";

export const FETCH_DATA_SEARCHERS_REQUEST = 'FETCH_DATA_SEARCHERS_REQUEST';
export const FETCH_DATA_SEARCHERS_SUCCESS = 'FETCH_DATA_SEARCHERS_SUCCESS';
export const FETCH_DATA_SEARCHERS_FAILURE = 'FETCH_DATA_SEARCHERS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataSearchersRequest = () => {
    return {
        type: FETCH_DATA_SEARCHERS_REQUEST,
    };
};

const fetchDataSearchersSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_SEARCHERS_SUCCESS,
        payload: data
    };
};

const fetchDataSearchersFailure = (error: any) => {
    return {
        type: FETCH_DATA_SEARCHERS_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataSearchersRequest());
        try {
            const response = await Find('searchers', query, page, pageSize);
            dispatch(fetchDataSearchersSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new SearchersAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataSearchersFailure(error.message));
        }
    };
};
